import { getKeys } from './getKeys'

export const homeSettingsTranslations = {
  LOG_OPTIONS_CHANGED:
    "Your changes have not been saved. Someone changed this home's log options while you were editing. Please refresh the page and try again.",
  SAVE_FAILED: 'Your changes have not been saved. Please try again.'
}

export const homeSettingsConstants = getKeys(homeSettingsTranslations)
